import { inject, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { PageActionStateService } from "app/core/store/page-action/page-action.state.service";
import { ErreurService } from "app/main/authentification/erreur.service";
import { SuccesSnakBarComponent } from "app/main/components/succes-snak-bar/succes-snak-bar.component";
import { RessourceFormComponent } from "app/main/plus/ressources/ressource-form/ressource-form.component";
import { RessourceService } from "app/main/plus/ressources/ressource/ressource.service";

@Injectable({
  providedIn: "root",
})
export class ResourceService {
  private dialog = inject(MatDialog); // Assuming you have MatDialog injected in your constructor

  private service = inject(RessourceService);

  private snackBar = inject(MatSnackBar);

  private errService = inject(ErreurService); // Assuming you have ErrorService injected in your constructor

  private _pageActionStateService = inject(PageActionStateService);

  addResource(): void {
    const dialogRef = this.dialog.open(RessourceFormComponent, {
      panelClass: "common-dialog-style",
      width: "auto",
      data: {
        action: "new",
      },
    });
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.service.addRessource(response).subscribe(
          () => {
            if (response) {
              this.snackBar.openFromComponent(
                SuccesSnakBarComponent,
                {
                  duration: 3000,
                },
              );
              this._pageActionStateService.setFetchData('ressource');
            }
          },
          (err) =>
            this.errService.popError(
              err,
              "Erreur s'est produit lors d'ajout. \n Essayez plus tard.'",
            ),
        );
      }
    });
  }
}
